export default __webpack_public_path__ + "static/media/FS-ABOUT-QUIENESSOMOS-IMAGEN-VIDEO.f7f9122d.png";